import React from 'react';
import RestEdit from 'containers/rest/Edit';
import Form from '../components/Form';
import { useSelector } from '@redux';
import { DynamicObjectType } from 'types/commons';

const CustomersEdit = () => {
  const currUser = useSelector<DynamicObjectType>(
    (state) => state.users.currentData,
  );

  const breadcrumbs = [
    {
      title: 'common.page.users',
      href: '/users',
    },
    {
      title: `#${currUser?.id}`,
    },
  ];

  return (
    <RestEdit model="bannedCustomers" breadcrumbs={breadcrumbs}>
      <Form />
    </RestEdit>
  );
};

export default CustomersEdit;
